import { schema } from 'normalizr'

const organization = new schema.Entity('organizations')

const role = new schema.Entity('roles')

const user = new schema.Entity('users', {}, { idAttribute: 'username' })

const userList = [user]

const membership = new schema.Entity('memberships', {
  organization: organization,
  userRole: role,
  user: user
})

const tag = new schema.Entity('tags', {
  organization: organization
})

const tagList = [tag]

const membershipList = [membership]

const caseNote = new schema.Entity('caseNotes')
const caseNoteList = [caseNote]

const documentType = new schema.Entity('documentTypes')
const documentTypeList = [documentType]

const fileUpload = new schema.Entity('fileUploads', {
  organization: organization
})

const fileObject = new schema.Entity('fileObjects', {
  organization: organization
})

const document = new schema.Entity('documents', {
  organization: organization,
  fileObject: fileObject,
  fileUpload: fileUpload,
  documentType: documentType
})

const documentList = [document]

const patient = new schema.Entity('patients', {
  organization: organization
})

const pathCase = new schema.Entity('cases', {
  organization: organization,
  patient: patient,
  tags: tagList,
  documents: documentList
})

const casePreferences = new schema.Entity('casePreferences', {
  organization: organization,
  pathCase: pathCase
})

const pathCaseList = [pathCase]

const anatomicSite = new schema.Entity('anatomicSites')

const anatomicSiteList = [anatomicSite]

const stainType = new schema.Entity('stainTypes')

const stainTypeList = [stainType]

const slideLabel = new schema.Entity('labels', {
  fileObject: fileObject
})

const slide = new schema.Entity('slides', {
  organization: organization,
  fileObject: fileObject,
  fileUpload: fileUpload,
  anatomicSite: anatomicSite,
  stainType: stainType,
  label: slideLabel
})

const slideList = [slide]

const annotation = new schema.Entity('annotations', {
  slide: slide
})

const annotationList = [annotation]

const caseSlide = new schema.Entity('caseSlides', {
  pathCase: pathCase,
  slide: slide
})

const caseSlideList = [caseSlide]

const form = new schema.Entity('forms')

const formList = [form]

const caseForm = new schema.Entity('caseForms', {
  pathCase: pathCase,
  form: form
})

const caseFormList = [caseForm]

const caseSlideForm = new schema.Entity('caseSlideForms', {
  pathCase: pathCase,
  caseSlide: caseSlide,
  form: form
})

const caseSlideFormList = [caseSlideForm]

const assignment = new schema.Entity('assignments', {
  user: user,
  caseForm: caseForm
})

const assignmentList = [assignment]

const formResponse = new schema.Entity('formResponses', {
  caseForm: caseForm,
  assignment: assignment
})

const formResponseList = [formResponse]

const caseTag = new schema.Entity('caseTags', {
  pathCase: pathCase,
  tag: tag
})

const caseTagList = [caseTag]

const trial = new schema.Entity('trials')
const trialList = [trial]

const trialEligibility = new schema.Entity('trialEligibilities', {
  trial: trial
})

const trialEligibilityList = [trialEligibility]

const patientEligibilityNote = new schema.Entity('patientEligibilityNotes', {
  patient: patient,
  trialEligibility: trialEligibility
})

const patientEligibilityNoteList = [patientEligibilityNote]

const patientEligibilityVerification = new schema.Entity('patientEligibilityVerifications', {
  patient: patient,
  trialEligibility: trialEligibility
})

const patientEligibilityVerificationList = [patientEligibilityVerification]

const patientEligibilityEvaluationResult = new schema.Entity(
  'patientEligibilityEvaluationResults',
  {},
  {
    idAttribute: (value, parent) => parent.id
  }
)

const trialCriteriaDTO = new schema.Entity('trialCriteriaDTOs', {
  trialEligibility: trialEligibility,
  trialIdentificationKeyNotes: patientEligibilityNoteList,
  patientEligibilityVerification: patientEligibilityVerification,
  patientEligibilityEvaluationResults: patientEligibilityEvaluationResult
})

const trialCriteriaDTOList = [trialCriteriaDTO]

const trialInclusionExclusionDTO = new schema.Entity('trialInclusionExclusionDTOs', {
  inclusion: trialCriteriaDTOList,
  exclusion: trialCriteriaDTOList
})

const trialInclusionExclusionDTOList = [trialInclusionExclusionDTO]

const organizationTrial = new schema.Entity('organizationTrials', {
  organization: organization,
  trial: trial
})

const organizationTrialList = [organizationTrial]

const trialIdentificationStatus = new schema.Entity('trialIdentificationStatus')

const trialIdentificationStatusList = [trialIdentificationStatus]

const trialIdentification = new schema.Entity('trialIdentifications', {
  patient: patient,
  organizationTrial: organizationTrial,
  trialIdentificationStatus: trialIdentificationStatus
})

const trialIdentificationList = [trialIdentification]

const presentationPreparer = new schema.Entity('presentationPreparers', {
  user: user
})
const presentationPreparerList = [presentationPreparer]

const presentation = new schema.Entity('presentations', {
  organization: organization,
  presenter: user,
  preparers: presentationPreparerList,
  cases: pathCaseList,
  tags: tagList
})
const presentationList = [presentation]

const presentationViewTrialIdentificationDTO = new schema.Entity(
  'presentationViewTrialIdentificationDTOs',
  {
    trialIdentifications: trialIdentificationList
  }
)

const presentationViewTrialIdentificationDTOList = [presentationViewTrialIdentificationDTO]

const presentationDTO = new schema.Entity('presentationDTOs', {
  presentation: presentation,
  trialIdentifications: presentationViewTrialIdentificationDTOList
})

const presentationDTOList = [presentationDTO]
const biomarker = new schema.Entity('biomarkers')

const biomarkerList = [biomarker]

const biomarkerMethod = new schema.Entity('biomarkerMethods')

const biomarkerMethodList = [biomarkerMethod]

const biomarkerMethodResult = new schema.Entity('biomarkerMethodResults')

const biomarkerMethodResultList = [biomarkerMethodResult]

const genomicsReport = new schema.Entity('genomicsReports', {
  case: pathCase,
  document: document,
  patient: patient
})

const biomarkerTestResult = new schema.Entity('biomarkerTestResults', {
  biomarker: biomarker,
  biomarkerMethod: biomarkerMethod,
  biomarkerMethodResult: biomarkerMethodResult,
  genomicsReport: genomicsReport,
  patient: patient
})

const biomarkerTestResultList = [biomarkerTestResult]

const diagnosisHistology = new schema.Entity('diagnosisHistologies')
const diagnosisHistologyList = [diagnosisHistology]
const diagnosisSite = new schema.Entity('diagnosisSites')
const diagnosisSiteList = [diagnosisSite]
const diagnosisGrade = new schema.Entity('diagnosisGrades')
const diagnosisGradeList = [diagnosisGrade]
const diagnosisStage = new schema.Entity('diagnosisStages')
const diagnosisStageList = [diagnosisStage]

const metastasis = new schema.Entity('metastases')
const metastasisList = [metastasis]

const diagnosis = new schema.Entity('diagnoses')

const diagnosisList = [diagnosis]

const diagnosisData = new schema.Entity('diagnosisData', {
  diagnoses: diagnosisList,
  diagnosisSites: diagnosisSiteList,
  diagnosisStages: diagnosisStageList,
  diagnosisGrades: diagnosisGradeList,
  diagnosisHistologies: diagnosisHistologyList,
  diagnosisMetastases: metastasisList
})

const patientDiagnosis = new schema.Entity('patientDiagnoses', {
  organization: organization,
  patient: patient,
  diagnosis: diagnosis,
  diagnosisHistology: diagnosisHistology,
  diagnosisStage: diagnosisStage,
  diagnosisGrade: diagnosisGrade,
  diagnosisSite: diagnosisSite
})

const patientDiagnosisList = [patientDiagnosis]

const race = new schema.Entity('races')
const ethnicity = new schema.Entity('ethnicities')
const gender = new schema.Entity('genders')

const raceList = [race]
const ethnicityList = [ethnicity]
const genderList = [gender]

const demographicsData = new schema.Entity('demographics', {
  races: raceList,
  ethnicities: ethnicityList,
  genders: genderList
})

const patientDemographics = new schema.Entity('patientDemographics', {
  patient: patient,
  gender: gender,
  race: race,
  ethnicity: ethnicity
})

const trialNotificationPreferences = new schema.Entity('trialNotificationPreferences', {
  organization: organization,
  user: user,
  trial: trial
})

const trialNotificationPreferencesList = [trialNotificationPreferences]

export const schemas = {
  presentationDTO,
  presentationDTOList,
  presentationViewTrialIdentificationDTO,
  presentationViewTrialIdentificationDTOList,
  trialIdentificationStatus,
  trialIdentificationStatusList,
  metastasis,
  metastasisList,
  race,
  raceList,
  ethnicity,
  ethnicityList,
  gender,
  genderList,
  demographicsData,
  patientDemographics,
  organization,
  user,
  membership,
  membershipList,
  patient,
  pathCase,
  pathCaseList,
  casePreferences,
  fileObject,
  slide,
  slideList,
  anatomicSite,
  anatomicSiteList,
  stainType,
  stainTypeList,
  fileUpload,
  form,
  formList,
  formResponse,
  formResponseList,
  caseForm,
  caseFormList,
  caseSlideForm,
  caseSlideFormList,
  annotation,
  annotationList,
  caseSlide,
  caseSlideList,
  caseNote,
  caseNoteList,
  document,
  documentList,
  documentType,
  documentTypeList,
  assignment,
  assignmentList,
  tag,
  tagList,
  caseTag,
  caseTagList,
  trial,
  trialList,
  patientEligibilityNote,
  patientEligibilityNoteList,
  patientEligibilityVerification,
  patientEligibilityVerificationList,
  trialEligibility,
  trialEligibilityList,
  trialInclusionExclusionDTO,
  trialInclusionExclusionDTOList,
  organizationTrial,
  organizationTrialList,
  trialIdentification,
  trialIdentificationList,
  trialCriteriaDTO,
  trialCriteriaDTOList,
  presentation,
  presentationList,
  presentationPreparer,
  presentationPreparerList,
  biomarkerTestResult,
  biomarkerTestResultList,
  biomarkerList,
  biomarkerMethodList,
  biomarkerMethodResultList,
  patientDiagnosis,
  patientDiagnosisList,
  diagnosis,
  diagnosisList,
  diagnosisHistology,
  diagnosisHistologyList,
  diagnosisSite,
  diagnosisSiteList,
  diagnosisGrade,
  diagnosisGradeList,
  diagnosisStage,
  diagnosisStageList,
  diagnosisData,
  trialNotificationPreferences,
  trialNotificationPreferencesList
}
